import { Check, Loader2 } from 'lucide-react';
import { ProcessingStep } from '../../types/analysis';

interface ProcessingStepsProps {
  steps: ProcessingStep[];
  currentStep: number;
}

export default function ProcessingSteps({ steps, currentStep }: ProcessingStepsProps) {
  return (
    <div className="space-y-3">
      {steps.map((step, index) => {
        const isActive = index === currentStep;
        const isCompleted = index < currentStep;

        return (
          <div
            key={step.id}
            className={`flex items-center space-x-3 p-4 rounded-xl transition-all duration-300 ${
              isActive
                ? 'bg-accent-400/10 dark:bg-accent-400/10 border border-accent-400/30'
                : isCompleted
                ? 'bg-success-50 dark:bg-success-900/10'
                : 'bg-navy-50 dark:bg-navy-800/50'
            }`}
          >
            <div className={`
              flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300
              ${isCompleted ? 'bg-success-100 dark:bg-success-900/30' :
                isActive ? 'bg-accent-400/20 dark:bg-accent-400/30' :
                'bg-navy-100 dark:bg-navy-700'}
            `}>
              {isCompleted ? (
                <Check className="w-5 h-5 text-success-600 dark:text-success-400" />
              ) : isActive ? (
                <Loader2 className="w-5 h-5 text-accent-500 dark:text-accent-400 animate-spin" />
              ) : (
                <span className="w-2 h-2 bg-navy-300 dark:bg-navy-500 rounded-full" />
              )}
            </div>

            <div className="flex-grow">
              <h4 className={`font-medium transition-colors duration-300 ${
                isActive ? 'text-accent-600 dark:text-accent-400' :
                isCompleted ? 'text-success-600 dark:text-success-400' :
                'text-navy-500 dark:text-navy-400'
              }`}>
                {step.title}
              </h4>
              <p className="text-sm text-navy-500 dark:text-navy-400">
                {step.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
